import { usePageContext } from "@/lib/context/page-context";
import { useUser } from "@/lib/context/user-context";
import {
  useIdentifyToFullStory,
  useInstallFullStory,
} from "@zapier/react-fullstory";

export function FullStory() {
  const { isEmbedded } = usePageContext();
  /**
   * We do not want to install FullStory in embedded pages.
   * Most of our embedded pages hosts Chatbots which are not relevant to why we are adding FullStory.
   *
   * Please note that the "default" heuristics for when FullStory is disabled still apply,
   * even when this `isEmbedded` is false.
   */
  useInstallFullStory({ isDisabled: isEmbedded });

  const { user } = useUser();
  if (!user) {
    return null;
  }

  const fullStoryUser: FullStoryUser = {
    id: user.id,
    fullName: `${user.firstName} ${user.lastName}`,
    email: user.email,
  };
  return <FullStoryIdentify user={fullStoryUser} />;
}

interface FullStoryUser {
  id: string; // customuserId of user
  fullName: string;
  email: string;
}

const FullStoryIdentify = ({ user }: { user: FullStoryUser }) => {
  useIdentifyToFullStory(user);

  return null;
};
